import { z } from 'zod';
import { DocId, IsoTimestamp } from '../common.js';
/**
 * Canonical-facts overlay.
 *
 * RAG temporal-correctness band-aid. The Knowledgebase ingests documents
 * created over many years; some of those documents now contradict current
 * reality (the most obvious example: the OneView application URL changed
 * from `firm-it.co.za` to `oneview.nebula.co.za` and old docs still cite
 * the legacy URL).
 *
 * The Knowledge Agent injects every enabled fact into the LLM context as
 * an authoritative override block — "these statements override anything
 * in the retrieved fragments that contradicts them." Admins curate the
 * list via `/admin/documents`.
 *
 * Top-level collection: `canonical_facts/{id}`. Cross-tenant; kb_admin
 * RBAC. Shared-corpus exception is implicit — overlays apply to every
 * tenant's agent answers.
 */
export const CanonicalFact = z.object({
    id: DocId,
    statement: z
        .string()
        .min(8, 'A canonical fact needs at least 8 characters.')
        .max(1000, 'Keep canonical facts under 1000 characters — they ride in every prompt.'),
    tags: z.array(z.string().min(1).max(40)).max(10).default([]),
    enabled: z.boolean().default(true),
    createdAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
    updatedBy: z.string().min(1).max(100),
});
export const CanonicalFactInput = CanonicalFact.pick({
    statement: true,
    tags: true,
    enabled: true,
}).partial({ tags: true, enabled: true });
//# sourceMappingURL=canonical-fact.js.map